/** Formats a dollar amount (e.g. 50 → "$50") */
export const formatRewardAmount = (amount: number): string => `$${amount}`;

/** Default fallback amounts */
const DEFAULT_REWARD = 50;
const DEFAULT_DISCOUNT = 50;

/**
 * Returns the appropriate referral reward copy based on whether amounts match.
 * - Same amounts: "You both earn $50"
 * - Different amounts: "You earn $50, they get $40 off"
 */
export const getReferralRewardText = (
  referrerReward?: number | null,
  signupDiscount?: number | null,
): {
  symmetric: boolean;
  referrerAmount: number;
  signupAmount: number;
  headline: string;
  description: string;
} => {
  const referrerAmount = referrerReward ?? DEFAULT_REWARD;
  const signupAmount = signupDiscount ?? DEFAULT_DISCOUNT;
  const symmetric = referrerAmount === signupAmount;

  return {
    symmetric,
    referrerAmount,
    signupAmount,
    headline: symmetric
      ? `You both earn ${formatRewardAmount(referrerAmount)}`
      : `You earn ${formatRewardAmount(referrerAmount)}, they get ${formatRewardAmount(signupAmount)} off`,
    description: symmetric
      ? `You and your colleague each get ${formatRewardAmount(referrerAmount)} credit when they subscribe.`
      : `You get ${formatRewardAmount(referrerAmount)} credit and your colleague gets ${formatRewardAmount(signupAmount)} off when they subscribe.`,
  };
};
